import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC-UMxMKH2sP0hHze6co2Kzd5DsDqTZMOA",
  authDomain: "stichb-bd487.firebaseapp.com",
  projectId: "stichb-bd487",
  storageBucket: "stichb-bd487.firebasestorage.app",
  messagingSenderId: "862723116704",
  appId: "1:862723116704:web:4187c2ff8e4c8850e943c5",
  measurementId: "G-QRHTL472C9",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");

export const analyticsPromise = isSupported().then((supported) =>
  supported ? getAnalytics(app) : null
);

export default app;